// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g6h3","colBig":"styles_colBig__219YM","colSmall":"styles_colSmall__4fnV4"};